import { render, staticRenderFns } from "./ns-signup-vue.vue?vue&type=template&id=1d41c2b9&scoped=true&"
import script from "./ns-signup-vue.vue?vue&type=script&lang=js&"
export * from "./ns-signup-vue.vue?vue&type=script&lang=js&"
import style0 from "./ns-signup-vue.vue?vue&type=style&index=0&id=1d41c2b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d41c2b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d41c2b9')) {
      api.createRecord('1d41c2b9', component.options)
    } else {
      api.reload('1d41c2b9', component.options)
    }
    module.hot.accept("./ns-signup-vue.vue?vue&type=template&id=1d41c2b9&scoped=true&", function () {
      api.rerender('1d41c2b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/loyalty-elements/src/ns-signup-vue/ns-signup-vue.vue"
export default component.exports